import React, { Component } from 'react'
import Header from '../Header'
import { connect } from 'react-redux'
import { Container } from 'react-bootstrap'
import { bakeryActions } from '../../redux/actions/bakeryActions'

export class WishList extends Component {

    buyCake = () => {
        this.props.buyCake()
    }

    render() {
        return (
            <>
                <Header />

                <Container className='home-container'>
                    <p>Number Of Cakes - {this.props.numberOfCakes}</p>
                    <button className='btn btn-success' onClick={this.buyCake}>Buy Cake</button>
                </Container>
            </>
        )
    }
}

const mapStateToProps = (state) => {
  return {
    numberOfCakes: state.bakeryReducer.numberOfCakes
  }
}

const mapDispatchToProps = (dispatch) => {
    return {
        buyCake: () => dispatch(bakeryActions.buyCake())
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(WishList)
